import { ApiRoutes } from '@/services/ApiRoutes.js';
import { BackendAPI } from '@/services/BackendAPI.js';

export default {
  all(data = {}) {
    return BackendAPI('get', ApiRoutes.tamaiClass.all(), data);
  },
  get(id) {
    return BackendAPI('get', ApiRoutes.tamaiClass.get(id));
  },
  create(data) {
    return BackendAPI('post', ApiRoutes.tamaiClass.create(), data);
  },
  update(id, data) {
    return BackendAPI('put', ApiRoutes.tamaiClass.update(id), data);
  },
  frozen(id, data = {}) {
    return BackendAPI('put', ApiRoutes.tamaiClass.frozen(id), data);
  },
};
